module.exports = __webpack_public_path__ + "files/67e225f3981639ea7411de0481b407db.png";